import styled from "styled-components";
import { colors } from "../element/elements.js";

export const Styles = styled.div`
  .sticky-menu {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 11;
    animation: 300ms ease-in-out 0s normal none 1 fadeInDown;
    background: #ffffff;
    height: 75px;
    padding-top: 18px;
    box-shadow: 0 0 20px -10px #222222;
    .logo {
      height: 40px;
      width: 160px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      flex-shrink: 0;

      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
          display: block;
        }
      }

      @media (max-width: 1199px) {
        height: 40px;
        width: 110px;
      }

      @media (max-width: 767px) {
        height: 40px;
        width: 100px;
      }
    }

    div.menu-box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      ul.nav.menu-nav {
        display: flex;
        align-items: center;
        margin: 0;
        padding: 0;
        list-style: none;
        gap: 15px;

        li.nav-item {
          position: relative;

          a.nav-link {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: ${colors.black1};
            text-transform: uppercase;
            font-weight: 500;
            padding: 10px 10px;

            i {
              font-size: 12px;
              margin-left: 5px;
            }

            &:after {
              content: none;
            }

            &:hover {
              color: ${colors.red};
            }

            @media (max-width: 1199px) {
              padding-left: 0;
              padding-right: 8px;
            }

            @media (max-width: 991px) {
              padding-right: 6px;
            }
          }

          ul.dropdown {
            position: absolute;
            left: 0;
            top: 100%;
            min-width: 190px;
            background: #fff;
            border: 1px solid ${colors.border1};
            text-align: left;
            padding: 0;
            border-radius: 5px;
            transition: 0.2s ease;
            opacity: 0;
            transform: scaleY(0);
            visibility: hidden;
            z-index: 999;
            transform-origin: center top 0;

            li.nav-item {
              position: relative;

              a.nav-link {
                font-size: 13px;
                color: ${colors.text1};
                padding: 10px 20px;
                text-transform: capitalize;
                font-weight: 400;
                margin-right: 0;
                border-bottom: 1px solid ${colors.border1};

                &:hover {
                  color: ${colors.red};

                  i {
                    color: #fff;
                  }
                }

                i {
                  float: right;
                  margin-top: 4px;
                }
              }

              &:last-child {
                margin-left: 0;

                a.nav-link {
                  border-bottom: none;
                }
              }

              ul.dropdown2 {
                position: absolute;
                top: 0;
                left: 100%;
                min-width: 180px;
                background: #fff;
                border: 1px solid ${colors.border1};
                transition: 0.2s ease;
                opacity: 0;
                transform: scaleY(0);
                visibility: hidden;
                z-index: 999;
                transform-origin: center top 0;
              }

              &:hover {
                ul.dropdown2 {
                  opacity: 1;
                  transform: scaleY(1);
                  visibility: visible;
                }
              }
            }
          }

          &:hover {
            ul.dropdown {
              opacity: 1;
              transform: scaleY(1);
              visibility: visible;
            }
          }
        }
      }

      .user-auth {
        margin-right: 35px;
        display: flex;
        align-items: center;
        gap: 15px;
        font-size: 13px;
        color: ${colors.text4};

        a,
        button.logout-btn {
          font-size: 13px;
          color: #fff;
          background: ${colors.red};
          padding: 5px 10px;
          border-radius: 5px;
          text-transform: uppercase;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 6px;
          border: 1px solid ${colors.red};
          i {
            font-size: 16px;
            color: #fff;
          }

          &:hover {
            background: ${colors.red_bg2};
          }
        }

        @media (max-width: 1199px) {
          margin-right: 20px;
          display: none;
        }
      }

      .apply-btn {
        margin-left: 15px;

        a {
          font-size: 13px;
          color: #fff;
          background: ${colors.red};
          padding: 6px 12px;
          border-radius: 5px;
          display: flex;
          align-items: center;
          gap: 6px;

          i {
            font-size: 16px;
          }

          &:hover {
            background: ${colors.red2};
          }
        }

        @media (max-width: 1199px) {
          margin-left: 10px;
        }

        @media (max-width: 991px) {
          display: none;
        }
      }
    }

    @media (max-width: 767px) {
      display: none;
    }
  }

  .sticky-menu.sticky {
    display: block;

    @media (max-width: 767px) {
      display: none;
    }
  }
`;
